export const FETCH_START = "setLoading";
export const SET_ALARMS = "setAlarms";

export const SET_EXCHANGES = "setExchanges";
export const SET_STOCKS = "setStocks";
